<div [class]="panelClasses">
  <div class="flex flex-col gap-2">
    <h2 [class]="titleClasses">{{ title }}</h2>
    <p [class]="textClasses">{{ text }}</p>
  </div>

  <div [class]="actionsClasses">
    <button type="button" z-button [zType]="cancelType" [class]="buttonClasses" (click)="cancel()">
      {{ cancelText }}
    </button>
    <button type="button" z-button [zType]="okType" [class]="buttonClasses" (click)="ok()">
      {{ okText }}
    </button>
  </div>
</div>
